import React from 'react'

const PasswordText = (props) => {
  return (
    <span>
      <div>
        <h5> {'Nota'}</h5>
      </div>
      {'Tu contraseña debe:'}
      <div className='element-form-label'>
        <ul>
          <li>{'Tener entre 8 y 15 caracteres'}</li>
          <li>{'No repetir caracteres consecutivos'}</li>
          <li>{'Al menos un número'}</li>
          <li>{'Al menos una letra minúscula'}</li>
          <li>{'Al menos una letra mayúscula'}</li>
          <li>{'Al menos un carácter especial de estos #?!@$%&-'}</li>
        </ul>
      </div>
    </span>

  )
}

export default PasswordText
